/* eslint-disable no-unused-vars */
import TaskService from "@/services/task";

import {  } from "./types";

export async function deleteTasks({commit}, params) {
  const {data} = await TaskService.delete(params);
  return data;
}

export async function makeTodo({commit}, params) {
  const {data} = await TaskService.makeTodo(params);
  return data;
}

export async function fetchById({commit}, id) {
  const {data} = await TaskService.getById(id);
  const {task} = data.data;
  return task;
}

export async function copyToJob({commit}, params) {
  const {data} = await TaskService.copyToJob(params);
  return data;
}